import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { exposeDebugHandle } from "./debug";
import { appUpdater } from "./pwa/register";
import { syncIdentity } from "./session/use-identity";
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "./styles/reset.css";
import "@codeshare/theme/theme.css";
import "./styles/app.css";

exposeDebugHandle();
syncIdentity();
if (import.meta.env.PROD) void appUpdater.register();

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
